import { MathUtils, Vector2 } from 'three';
import { smoothstep } from 'three/src/math/MathUtils.js';

import { lisa } from '../Lisa.js';
import { DEVICE, EVENTS } from '../constants.js';

import { globalUniforms } from './uniforms.js';

export class DeviceMotion {
	#previousOrientation = new Vector2();

	constructor() {
		lisa.state.register(this);
		this.isAttached = false;

		document.addEventListener('click', this.#onPointerDown);
		window.addEventListener('devicemotion', this.#onDeviceMotion);
	}

	onAttach() {
		this.isAttached = true;
	}

	onDetach() {
		window.removeEventListener('devicemotion', this.#onDeviceMotion);
	}

	#onPointerDown = () => {
		// @ts-ignore
		DeviceMotionEvent.requestPermission?.();
		window.addEventListener('devicemotion', this.#onDeviceMotion);
		document.removeEventListener('click', this.#onPointerDown);
	};

	/**
	 *
	 * @param {DeviceMotionEvent} e
	 */
	#onDeviceMotion = (e) => {
        if(!e.accelerationIncludingGravity || !e.accelerationIncludingGravity.x) return; // Device motion isn't really supported

		if (!DEVICE.MOTION) {
			DEVICE.MOTION = true;
		}
		lisa.state.emit(EVENTS.DEVICE_ACCELERATION, e.rotationRate);

		// globalUniforms.uMotion.value.x = MathUtils.clamp(e.beta - this.#previousOrientation.x, -1, 1);
		// this.#previousOrientation.x = e.beta;
		// globalUniforms.uMotion.value.y = MathUtils.clamp(e.alpha - this.#previousOrientation.y, -1, 1);
		// this.#previousOrientation.y = e.alpha;
		globalUniforms.uMotion.value.x = smoothstep(e.rotationRate.beta, -90, 90) * 2 - 1;

		globalUniforms.uMotion.value.y = smoothstep(e.rotationRate.alpha, -90, 90) * 2 - 1;

		// console.log(globalUniforms.uMotion.value.y.toFixed(1));
	};
}
